// iter414 — Edit-mode banner extracted from DashboardPage.jsx
// Surfaces a sticky orange strip at the top of the dashboard while
// the user is in layout-edit mode. Clicking "Done Editing" exits.
import { Button } from '@/components/ui/button';
import { GripVertical, Lock } from 'lucide-react';

export function EditModeBanner({ onExit }) {
  return (
    <div
      className="bg-orange-50 border border-orange-200 rounded-xl p-3 flex items-center justify-between"
      data-testid="edit-mode-banner"
    >
      <div className="flex items-center gap-2">
        <GripVertical size={16} className="text-orange-500" />
        <span className="text-sm font-medium text-orange-700">Layout Edit Mode</span>
        <span className="text-xs text-orange-500">Drag widgets to rearrange, resize from corners</span>
      </div>
      <Button
        size="sm"
        className="bg-orange-500 hover:bg-orange-600 text-white rounded-lg text-xs"
        onClick={onExit}
        data-testid="edit-mode-banner-exit"
      >
        <Lock size={12} className="mr-1" /> Done Editing
      </Button>
    </div>
  );
}

export default EditModeBanner;
